import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { openSnackbar as openGlobalSnackbar } from "../../../reducers/snackbar"
import { isConcierge } from "../../users/accountRole"
import { isActiveSubscriptionStatus } from "../../users/billing"
import { selectProfile, selectSubscription } from "../../users/reducer"
import {
  TrialFinishedRoadblockDialogData,
  useTrialFinishedDialogUtils,
} from "../components/TrialFinishedRoadblockDialog"
import { openConciergeGreetingRequiredDialog } from "../reducer"
import { selectCRMSettings } from "../reducer"
import { SETTINGS_TABS, createSettingsTabURL } from "../settings"
import { useGlobalCall } from "./GlobalCallProvider"
import { getOutboundCallGateState } from "./conciergeCallingGate"

export function useStartLeadCall(localSnackbar) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { startCall, isCallActive } = useGlobalCall()
  const crmSettings = useSelector(selectCRMSettings)
  const profile = useSelector(selectProfile)
  const subscription = useSelector(selectSubscription)
  const { runOnlyIfSubscribed } = useTrialFinishedDialogUtils()

  function notify(message) {
    if (localSnackbar) {
      localSnackbar(message)
      return
    }
    dispatch(openGlobalSnackbar({ message }))
  }

  function requestCall(contact, options = {}) {
    if (!isActiveSubscriptionStatus(subscription?.status)) {
      notify("Subscribe to a paid plan to call leads from My Leads.")
      return false
    }
    if (subscription?.trialFinished) {
      runOnlyIfSubscribed(() => {},
      new TrialFinishedRoadblockDialogData("Making Calls", "Subscribe to make phone calls to your leads"))
      return false
    }
    if (isCallActive) {
      notify("Finish or end the current call before starting another.")
      return false
    }
    if (!contact?.phone) {
      notify("This lead does not have a phone number.")
      return false
    }
    switch (getOutboundCallGateState(crmSettings, profile)) {
      case "concierge_no_phone":
        navigate(createSettingsTabURL(SETTINGS_TABS.phoneSms))
        return false
      case "concierge_no_greeting":
        dispatch(openConciergeGreetingRequiredDialog())
        return false
      case "owner_no_phone":
        navigate(
          createSettingsTabURL(SETTINGS_TABS.phoneSms, { focus: "phone" })
        )
        return false
      case "ready":
      default:
        startCall({ ...contact, isLead: true }, options)
        return true
    }
  }

  return { requestCall, isCallActive }
}
